module.exports = __webpack_public_path__ + "static/media/RSmartPlus+.7e2833f5.jpg";